import { Body } from "./Body"
import { Root } from "./Root"
import { Footer } from "./Footer"
import { Header } from "./Header"
import { Status } from "./Status"

export const CustomContent = {
  Body,
  Root,
  Footer,
  Header,
  Status,
}
